module.exports = __webpack_public_path__ + "static/mobile-banner-homepgage-new-24Nov-af8a9d8a83e067d96a91d7246e2dfce6.jpg";